import { createAction } from '@reduxjs/toolkit';
import { site } from 'lib/src/shared/enums/site';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge, ChallengeDescriptionSectionRequest } from 'src/types/shared/Challenge';

export const createChallengeRequest = createAction('createChallengeRequest');
export const createChallengeSuccess = createAction<Challenge>('createChallengeSuccess');
export const createChallengeFailure = createAction('createChallengeFailure');

export const createChallenge = (postbody: CreateChallengeRequest) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(createChallengeRequest());
    try {
        const { data } = await api.post<CreateChallengeRequest, Challenge>(
            'admin/challenges',
            postbody,
        );

        dispatch(createChallengeSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, createChallengeFailure, e);
    }
};

export interface CreateChallengeRequest {
    challengeGroupID: number;
    name: string;
    startDate: Date | string;
    endDate: Date | string;
    // number of days after end date to allow finishing application
    gracePeriod: number;
    // description
    background: string;
    imageS3Key: string | null;
    partnerLogoS3Key: string | null;
    partnerSecondLogoS3Key: string | null;
    partnerThirdLogoS3Key: string | null;
    summaryImage1S3Key: string | null;
    summaryImage2S3Key: string | null;
    responseDate: Date | string;
    challengeLeadID: number | null;
    tagIDs: number[];
    businessTagIDs: number[];
    site: site;
    descriptionSections: ChallengeDescriptionSectionRequest[];
    workshopDate: Date | string;
    workshopAdminIDs: number[];
    assessmentStartDate: Date | string;
    assessorIDs: number[];
    pitchPresentationDate: Date | string;
    pitchPresentationAdminIDs: number[];
}
